/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __extends } from "tslib";
//module Shumway.AVM1.Lib {
import { AVM1Object } from '../runtime/AVM1Object';
import { getAwayJSAdaptee, wrapAVM1NativeClass } from './AVM1Utils';
import { AVM1ColorTransform, fromAVM1Object } from './AVM1ColorTransform';
import { HierarchicalProperties } from '@awayjs/scene';
import { AVM1SymbolBase } from './AVM1SymbolBase';
var AVM1Color = /** @class */ (function (_super) {
    __extends(AVM1Color, _super);
    function AVM1Color() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AVM1Color.createAVM1Class = function (context) {
        return wrapAVM1NativeClass(context, true, AVM1Color, [], ['getRGB', 'getTransform', 'setRGB', 'setTransform'], null, AVM1Color.prototype.avm1Constructor);
    };
    AVM1Color.prototype.avm1Constructor = function (target_mc) {
        if (target_mc) {
            this._target = this.context.resolveTarget(target_mc);
            if (this._target && this._target.adaptee && !this._target.adaptee.isAVMScene) {
                this._target.avmColor = this;
                this._targetAwayObject = getAwayJSAdaptee(this._target);
            }
        }
    };
    AVM1Color.prototype.changeTarget = function (target_mc) {
        if (target_mc && target_mc instanceof AVM1SymbolBase) {
            this._target = target_mc;
            this._target.avmColor = this;
            this._target._ctBlockedByScript = true;
            this._targetAwayObject = getAwayJSAdaptee(this._target);
        }
        else {
            this._target = null;
        }
    };
    AVM1Color.prototype.getRGB = function () {
        var transform = AVM1Color.prototype.getTransform.call(this);
        if (transform)
            return transform.getRgb();
        return null;
    };
    AVM1Color.prototype.getTransform = function () {
        if (this._targetAwayObject) {
            return AVM1ColorTransform.fromAwayColorTransform(this.context, this._targetAwayObject.transform.colorTransform);
        }
        return null;
    };
    AVM1Color.prototype.setRGB = function (offset) {
        var transform = AVM1Color.prototype.getTransform.call(this);
        if (transform) {
            transform.setRgb(offset);
            AVM1Color.prototype.setTransform.call(this, transform);
        }
        if (this._target)
            this._target._ctBlockedByScript = true;
    };
    AVM1Color.prototype.setTransform = function (transform) {
        if (this._targetAwayObject && transform) {
            var tf = transform;
            if (!(transform instanceof AVM1ColorTransform)) {
                if (transform instanceof AVM1Object) {
                    tf = fromAVM1Object(transform);
                }
            }
            if (tf) {
                this._targetAwayObject.transform.colorTransform._rawData[0] = tf._rawData[0];
                this._targetAwayObject.transform.colorTransform._rawData[1] = tf._rawData[1];
                this._targetAwayObject.transform.colorTransform._rawData[2] = tf._rawData[2];
                this._targetAwayObject.transform.colorTransform._rawData[3] = tf._rawData[3];
                this._targetAwayObject.transform.colorTransform._rawData[4] = tf._rawData[4];
                this._targetAwayObject.transform.colorTransform._rawData[5] = tf._rawData[5];
                this._targetAwayObject.transform.colorTransform._rawData[6] = tf._rawData[6];
                this._targetAwayObject.transform.colorTransform._rawData[7] = tf._rawData[7];
                this._targetAwayObject.transform.invalidateColorTransform();
                this._targetAwayObject.invalidate();
                this._targetAwayObject._invalidateHierarchicalProperties(HierarchicalProperties.COLOR_TRANSFORM);
            }
        }
        if (this._target)
            this._target._ctBlockedByScript = true;
    };
    return AVM1Color;
}(AVM1Object));
export { AVM1Color };
